import axios from 'axios';

/**
 * Read-only client for surfacing Milo notebook-origin records inside the destination
 * tabs (Guests / Vendors / Program / Messaging). These records live in SIDE collections
 * — fetching them can never expose or change a live guest/vendor/program/message field.
 * The platform axios interceptor attaches the admin Bearer token.
 */
const API = process.env.REACT_APP_BACKEND_URL;

export async function fetchSurfaced(kind) {
  const res = await axios.get(`${API}/api/notebook/surfaced/${kind}`);
  return (res.data && res.data.items) || [];
}

// undo (delete) a surfaced item via its governed write-back id.
export async function undoSurfaced(writebackProposalId) {
  const res = await axios.post(`${API}/api/notebook/writeback/${writebackProposalId}/undo`, {});
  return res.data;
}

// edit-in-place: correct the primary text of a Milo-origin surfaced record (operator-gated
// server-side; only created_via='milo_notebook' rows are editable — human rows can't be touched).
export async function editSurfaced(kind, id, text) {
  const res = await axios.patch(`${API}/api/notebook/surfaced/${kind}/${id}`, { text });
  return res.data;
}
